import React, { useEffect, useState } from "react"
import supabase from "../supabaseconfig"
import style from "./praktiskinfo.module.css"

type InfoData = {
    alarm_kode: string | null
    nokkelskap_kode: string | null
    adresse: string | null
    kart_url: string | null
    miguel_whatsapp: string | null
}

type Seksjon = {
    ikon: string
    tittel: string
    innhold: React.ReactNode
}

function lagSeksjoner(koder: InfoData | null): Seksjon[] { return [
    {
        ikon: "🏠",
        tittel: "Adresse & transport",
        innhold: (
            <>
                <p>
                    {koder?.kart_url && koder?.adresse
                        ? <><strong>Adresse:</strong> <a className="lenkeknapp" href={koder.kart_url}>{koder.adresse}</a></>
                        : <><strong>Adresse:</strong> {koder?.adresse ?? "—"}</>
                    }
                </p>
                <p><strong>🚕 Taxi</strong> anbefales å booke gjennom <a className="lenkeknapp" href="https://nerjataxis.com/?gad_campaignid=232201021&gbraid=0AAAAADkJLIshgKRYNqd9N6__jEZqIryxR">Nerja Taxis</a>.</p>
                <p><strong>🚌 Buss</strong> tar ca. 1 t 45 min. Se <a className="lenkeknapp" href="https://www.alsa.com/en/coach/malaga-nerja">busstider og ruter</a>.</p>
            </>
        ),
    },
    {
        ikon: "🔧",
        tittel: "Manuel & Raquel",
        innhold: (
            <>
                <p>Manuel Losada Diaz er Residencens altmuligmann! Han er først og fremst bassengvaktmester og gartner. Han renser bassenget regelmessig og har egne nøkler til huset. Vær derfor ikke redd hvis det plutselig står en rolig spanjol og renser bassenget.</p>
                <p>Datteren hans, Raquel, står for vaskingen av huset.</p>
                <p>Manuel kan nås på WhatsApp: <strong>{koder?.miguel_whatsapp ?? "—"}</strong></p>
            </>
        ),
    },
    {
        ikon: "🚰",
        tittel: "Drikkevann og vann",
        innhold: (
            <>
                <p>Drikkevann kjøpes i butikken. Det er ikke samme vanntilførsel som tidligere, og vannet er ikke renset og bør ikke drikkes uten at det er kokt. Bruk kjøpevann i kaffetrakter — smaker bedre og mindre kalk. Anbefales også til tevann.</p>
                <p>Høsten 2024 ble vannet i nabolaget borte ved et par anledninger i flere timer av uklare årsaker. Hvis man trenger å trekke ned i toalettet mens vannet er borte, kan man ta en bøtte vann fra bassenget.</p>
            </>
        ),
    },
    {
        ikon: "🏊",
        tittel: "Bassenget",
        innhold: (
            <>
                <p>Husk at alle (små og store) må vaske seg godt og dusje før man bader i bassenget. Særlig når man kommer fra stranden. Om mulig er det fint å ha forskjellig badetøy og badehåndklær på stranden og i bassenget. Eventuelt må badetøy brukt på stranden skylles godt. Sololje, ting fra havet og svette endrer bakteriefloraen i bassenget.</p>
                <p>Legg i mer klor i filteret når mange bader og det er varmt. Varsle Siv/Manuel raskt hvis vannet begynner å bli uklart. Kjøp klor evt. i Agua pool-butikk i veien ved Lidl.</p>
                <p>Ta ut leker, madrasser m.m. slik at renseanlegget i bassenget får virke godt.</p>
                <p>Det kommer ofte støv med vinden — spyl gjerne flisene rundt bassenget.</p>
                <p>Rens sluket i dusjen ute (og inne) om vannet renner sakte ut. Sjekk alltid at vannet renner ned i sluket før man dusjer. Hvis gjester — sjekk dette før de tar dusjen i bruk.</p>
                <p>Det er regler i vellet om at man ikke skal henge håndklær og badetøy på gjerdene. Bruk tørkestativet.</p>
                <p>Gi plantene rundt bassenget litt vann.</p>
            </>
        ),
    },
    {
        ikon: "🔒",
        tittel: "Alarm og sikkerhet",
        innhold: (
            <>
                <p>Pass på at det er strøm på alarmanlegget ved skjenken i stuen. Sjekk at kontakter til utekameraene har strøm: ved lite vindu i stuen mot terrassen, bak pianoet og inne på værelset mot havet i hovedetasjen.</p>
                <p>Lurt å bruke alarmen når dere går fra huset. Kode: <strong>{koder?.alarm_kode ?? "—"}</strong>. Koden til ekstra nøkkelskap under trappen nede i hagen er <strong>{koder?.nokkelskap_kode ?? "—"}</strong>.</p>
                <p>Pass på at utgangsdøren fra stuen er låst — den går ikke alltid i lås av seg selv.</p>
                <p>Ikke slipp inn noen som hevder å skulle noe, for eksempel «gasskontrollør». Det er kun Manuel som trenger å komme inn, og han kommer vanligvis på lørdager og har egen nøkkel.</p>
                <p>Vi gjør oppmerksom på at alarmanlegget medfører videoovervåking på eiendommen.</p>
            </>
        ),
    },
    {
        ikon: "🚗",
        tittel: "Bilen",
        innhold: (
            <>
                <p>Bilen har blitt fornyet med diverse reparasjoner, deriblant nye bremseklosser i 2023. Service 4. mai 2026. Aircondition fylt gass i juli 2024.</p>
                <p>Gi beskjed hvis det er feil eller driftsproblemer.</p>
            </>
        ),
    },
    {
        ikon: "⚡",
        tittel: "Strøm",
        innhold: (
            <>
                <p>Det hender strømmen går — sjekk sikringsskapet i første skap i stort soverom oppe. Hvis strømmen er gått i hele området er det vanligvis noe arbeid som foregår et sted. Avvent, det kommer nok tilbake.</p>
                <p>Noen ganger går sikringen pga. overbelastning — reduser strømforbruket. Hvis f.eks. poolpumpen går kan dette skje. Hvis strømmen er borte bare i Residensen, slå av hovedsikringen og prøv igjen.</p>
                <p>Ikke sett inn kontakten til vinskapet. Det er ikke i orden.</p>
                <p>Sikringen som det står «bassenglys» på skal være av (ned). Virker og kan brukes.</p>
            </>
        ),
    },
    {
        ikon: "🍳",
        tittel: "Kjøkkenet",
        innhold: (
            <>
                <p>Hvis vaskemidler eller annet er i ferd med å forbrukes, kjøp inn nytt.</p>
                <p>Hvis det blir hvitt belegg i kjeler, la dem stå med litt eddik — da blir de blanke igjen.</p>
                <p>Viktig å holde kjøkkenet fritt for smuler for å hindre maur, kakerlakker og annet. Tørk av kjøkkenbenk og bord hver gang etter bruk.</p>
                <p>Hvis maur, bruk «Kvitt» maurmiddel. Står i første skap i stort soverom.</p>
                <p>Skriv dato på ting i matskuffen m.m. — penn ligger i skuffen.</p>
                <p>I 2025 har mange av pyntelistene løsnet. Lim ligger i boks med farlige ting i berederskapet.</p>
                <p>Salt må fylles i oppvaskmaskinen iblant. (Sist gjort 16.7.25)</p>
            </>
        ),
    },
    {
        ikon: "📺",
        tittel: "Stuen",
        innhold: (
            <>
                <p>Det er Chromecast på TV-en som man kan koble seg til. Passord til internett står på ruteren.</p>
                <p>Bruk brune eller hvite bomullstepper hvis barn er i sofaen — lettere å vaske enn trekkene på sofaen. Blir det likevel søl, er det fint om trekk vaskes.</p>
            </>
        ),
    },
    {
        ikon: "🚿",
        tittel: "Lukt fra slukene",
        innhold: (
            <>
                <p>Vannlåsene tørker ut — fyll vann i slukene på badene i begge etasjer og på takterrassen. Gjør det samme hvis det er lukt derfra.</p>
                <p>Hvis det blir lukt fra sluket i badene oppe, fyll vann i slukene i hotellfløyen og i slukene i 1. etasje.</p>
            </>
        ),
    },
]}

export default function PraktiskInfo() {
    const [åpen, setÅpen] = useState<string | null>(null)
    const [koder, setKoder] = useState<InfoData | null>(null)

    useEffect(() => {
        supabase()
            .from("informasjon")
            .select("alarm_kode, nokkelskap_kode, adresse, kart_url, miguel_whatsapp")
            .single()
            .then(({ data }) => setKoder(data))
    }, [])

    function toggleSeksjon(tittel: string) {
        setÅpen((prev) => (prev === tittel ? null : tittel))
    }

    return (
        <div>
            <div className="page">
                <h1 className="topHeader">PRAKTISK INFO</h1>
            </div>
            <div className={style.wrapper}>
                {lagSeksjoner(koder).map((seksjon) => {
                    const erÅpen = åpen === seksjon.tittel
                    return (
                        <div key={seksjon.tittel} className={style.item}>
                            <button
                                type="button"
                                className={`${style.header} ${erÅpen ? style.headerÅpen : ""}`}
                                onClick={() => toggleSeksjon(seksjon.tittel)}
                                aria-expanded={erÅpen}
                            >
                                <span className={style.headerVenstre}>
                                    <span className={style.ikon}>{seksjon.ikon}</span>
                                    {seksjon.tittel}
                                </span>
                                <span className={`${style.pil} ${erÅpen ? style.pilÅpen : ""}`}>›</span>
                            </button>
                            {erÅpen && (
                                <div className={style.innhold}>
                                    {seksjon.innhold}
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
